import React, { useEffect } from 'react'
import UserBox from '../../components/userbox/UserBox'
import UsersIcon from "../../assets/images/UsersIcon.png";
import PremiumUsersIcon from '../../assets/images/PremiumUsersIcon.png';
import RevenueIcon from '../../assets/images/RevenueIcon.png';
import { useDispatch, useSelector } from 'react-redux';
import { countPremiumUsers, countRevenue, countUsers } from './Slice/slice';
import Loader from '../../components/loader/Loader';

function Dashboard() {

    const dispatch = useDispatch();
    const { isLoading, countUserDetails,countPremiumUsersDetails,countRevenueDetails } = useSelector(state => state.dashboardSlice);

    useEffect(() => {
        dispatch(countUsers());
        dispatch(countPremiumUsers());
        dispatch(countRevenue());
    }, [dispatch])

    const userdata = [
        {
            customColor: '#316AFF',
            boxtitle: 'Total Number Of Users',
            num: countUserDetails.user_count,
            imagesource: UsersIcon
        },
        {
            customColor: '#27AE60',
            boxtitle: 'Premium Users',
            num: countPremiumUsersDetails.premium_users_count,
            imagesource: PremiumUsersIcon
        },
        {
            customColor: '#E67E22',
            boxtitle: 'Total Revenue',
            num: countRevenueDetails.total_sum,
            imagesource: RevenueIcon
        }
    ];


    return (
        <>
            {isLoading && <Loader />} 
            <div className='users main-Page-css' style={{ height: '94vh' }}>
                <div className='main-page-title'>Dashboard</div>
                <div className='row p-0'>
                    {userdata.map((data, index) => (
                        <div key={index} className='col-4'>
                            <UserBox {...data} />
                        </div>
                    ))}
                </div>
            </div>
            
        </>
    )
}

export default Dashboard